import React from 'react';
import { Link, Redirect } from "react-router-dom";
import RatingScale from './RatingScale';
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import MiniSpinner from "../common/MiniSpinner";
import VideoVisitSurvey from "./VideoVisitSurvey";

class AmbulatorySurvey extends React.Component {
    constructor() {
        super();
        this.centerRatingScale = this.centerRatingScale.bind(this);
        this.onRatingClick = this.onRatingClick.bind(this);
        this.submitSurvey = this.submitSurvey.bind(this);
        this.state = {
            selectedRating: 0,
            isSubmitted: false
        }
    }

    componentDidMount() {
        logUI("UI.AmbulatorySurvey.ComponentDidMount", new Date(), Tools.getURLPath());
        this.centerRatingScale();
    }

    centerRatingScale() {
        var surveyContainer;
        const windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
        if (typeof window !== 'undefined' && windowWidth < 576) {
            surveyContainer = window.document.querySelector('.rating-scale');
            if (surveyContainer) {
                surveyContainer.scrollLeft = (surveyContainer.scrollWidth && surveyContainer.clientWidth) ? ((surveyContainer.scrollWidth / 2) - (surveyContainer.clientWidth / 2)) : 400;
            }
        }
    }

    onRatingClick(selectedRating) {
        const { userName, serverData, location } = this.props;
        const isSdcVisit = location && location.state && location.state.isSdcVisit ? location.state.isSdcVisit : false;
        let surveyId = null;
        let questionId = null;
        if (isSdcVisit) {
            surveyId = serverData && serverData.surveyIdForSDC ? serverData.surveyIdForSDC : null;
            questionId = serverData && serverData.surveyQuestionIdForSDC ? serverData.surveyQuestionIdForSDC : null;
        } else {
            surveyId = serverData && serverData.surveyIdForAmbulatory ? serverData.surveyIdForAmbulatory : null;
            questionId = serverData && serverData.surveyQuestionIdForAmbulatory ? serverData.surveyQuestionIdForAmbulatory : null;
        }
        const requestData = {
            UserId: userName,
            SurveyId: surveyId,
            QuestionId: questionId,
            OptionId: "",
            OptionValue: selectedRating
        };        
        logUI("UI.AmbulatorySurvey.Submit.Click", new Date(), Tools.getURLPath(), { Rating: selectedRating, visitType: isSdcVisit ? "SDC" : "Ambulatory" });
        this.props.ambulatoryVideoVisitSurveyRequest(requestData);
        this.setState({ selectedRating: selectedRating, isSubmitted: true });
    }

    onDismissClick() {
        logUI("UI.AmbulatorySurvey.Dismiss.Click", new Date(), Tools.getURLPath());
    }

    submitSurvey() {
        this.setState({ isSubmitted: true });
    }

    render() {
        const { isSubmitted } = this.state;
        const { isPending, isSuccess, enableNewSurvey, location } = this.props;
        const csnID = location && location.state && location.state.csnId ? location.state.csnId : "";
        const isSdcVisit = location && location.state && location.state.isSdcVisit ? location.state.isSdcVisit : false;
        const twilioUserName = location && location.state && location.state.twilioUserName ? location.state.twilioUserName : "";

        return (
            <div className={"container-fluid body-content ambulatory-survey-container"}>
                <div className="row">
                    <div className="col-12">
                        {!isSubmitted ?
                            enableNewSurvey ? <VideoVisitSurvey isSdcVisit={isSdcVisit} csnId={csnID} twilioUserName={twilioUserName} submitSurvey={this.submitSurvey} /> :
                            <div className="row">
                                <div className="col-12 visit-survey-container">
                                    <div className="row visit-survey__body">
                                        <div className="col-12">
                                            <h1 className="step-heading step-heading-md">How was the quality of the video call?</h1>
                                            <div className="step-description">HELP US IMPROVE YOUR EXPERIENCE</div>
                                        </div>
                                        <div className="col-12 rating-scale-container">
                                            <RatingScale
                                                onRatingClick={this.onRatingClick}
                                                backgroundColors={["#f4436c", "#d95174", "#be607c", "#a36e84", "#887c8c", "#6c8b93", "#51999b", "#36a7a3", "#1bb6ab", "#00c4b3"]}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <div className="row rating-info">
                                                <div className="col-6">1 = Poor</div>
                                                <div className="col-6">10 = Great</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row visit-survey__footer">
                                        <div className="col-12">
                                            <Link className="btn text-btn" to={{ pathname: "/" }} onClick={this.onDismissClick}>DISMISS</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            isPending ?
                                <div className="row">
                                    <div className="col-12">
                                        <MiniSpinner />
                                    </div>
                                </div> : 
                                <React.Fragment>
                                    {!enableNewSurvey ?
                                        <div className="row">
                                            <div className="col-12 survey-status-container">
                                                <div className="row survey-status__body">
                                                    <div className="col-12">
                                                        <div className="step-heading-icon"><span className="icon-echeck-in" /></div>
                                                        <h1 className="step-heading step-heading-md success-heading">{isSuccess ? "Thank you for the feedback!" : "Thank you!"}</h1>
                                                    </div>
                                                </div>
                                                <div className="row survey-status__footer">
                                                    <div className="col-12">
                                                        <Link className="btn btn-primary" to={{ pathname: "/" }} onClick={() => logUI("UI.AmbulatorySurvey.Close.Clicked", new Date(), Tools.getURLPath())}>CLOSE</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> :
                                        <Redirect to="/" />
                                    }
                                </React.Fragment>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userName: state.domain.un,
        serverData: state.session.serverData,
        isPending: state.videoVisit.survey && state.videoVisit.survey.isWaiting,
        isSuccess: state.videoVisit.survey && state.videoVisit.survey.isSuccess,
        isFailure: state.videoVisit.survey && state.videoVisit.survey.isFailure,
        enableNewSurvey: state.session.serverData && state.session.serverData.enableNewSurvey
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ambulatoryVideoVisitSurveyRequest: (requestData) => dispatch({ type: types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST, data: requestData })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AmbulatorySurvey);